export const AGMTableRow = ({item, fetchedByGroupId, addPoi, userIsAdmin, itemIndex}) => {
    const displayLat = item.Real_Lat || item.Est_Lat
    const displayLng = item.Real_Lng || item.Est_Lng

    return(
        <tr className="bg-gray-50 border-t border-gray-200">
            <td className="px-4 py-2 sticky-left bg-gray-50" style={{background: 'oklch(0.985 0.002 247.839)'}}>{item.Site_Name}</td>
                          
            {/* if showing Original Name column, add another cell */}
            {fetchedByGroupId && 
                <td className="px-4 py-2"></td>
            }

            <td className="px-4 py-2">AGM</td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2">{displayLat ? Number(displayLat).toFixed(5) : null}</td>
            <td className="px-4 py-2">{displayLng ? Number(displayLng).toFixed(5) : null}</td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>
            <td className="px-4 py-2"></td>

            {/* if user is admin, they can add or delete POIs from table, so include table cells to fill out the row */}
            {userIsAdmin && 
                <>
                    <td className="px-4 py-2">
                        <button
                            onClick={() => addPoi(itemIndex +1)}
                            className="text-blue-500 hover:text-blue-700 w-max"
                        >
                            <i className="fa-solid fa-down-long"></i> Add
                        </button>
                    </td>
                    <td className="px-4 py-2"></td>
                </>

            }
            
            <td className="px-4 py-2"></td>
        </tr>
    )
}